import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router";
import EditTemplateProduct from "./EditTemplateProduct";
import TemplateInstanceProvider, {
  ACTIONS,
  createInstance,
} from "../../../../Providers/TemplateInstanceProvider";
import useTemplateInstance from "../../hooks/useTemplateInstance";
import { useShoppingCart } from "../../../providers/ShoppingCartProvider";
import { usePriceList } from "../../../providers/PriceListProvider";
import useTemplate from "../../../../hooks/useTemplate";
import { useTranslation } from "react-i18next";
import GreenScreenBackgroundsProvider from "../../Providers/GreenScreenBackgroundsProvider";
import { usePictureSets } from "../../../hooks/usePictureSets";
import RecentImagesProvider from "../../Providers/RecentImagesProvider";
import ProductRetouch from "@/react/Webshop/Mobile/Pages/ProductRetouch/ProductRetouch";
import useRetouch from "@/react/Webshop/hooks/useRetouch";

export default ({ orderLine }) => {
  const { currentPictureSet } = usePictureSets();

  return (
    <GreenScreenBackgroundsProvider jobUuid={currentPictureSet.job.uuid}>
      <TemplateInstanceProvider>
        <Wrapper orderLine={orderLine} />
      </TemplateInstanceProvider>
    </GreenScreenBackgroundsProvider>
  );
};

const Wrapper = ({ orderLine }) => {
  const [state, dispatch] = useTemplateInstance();
  const { getProductByUuid } = usePriceList();
  const history = useHistory();
  const { updateItem } = useShoppingCart();
  const { t } = useTranslation();

  console.log("Edit order line", orderLine);
  const [template, loading] = useTemplate(orderLine.template.uuid);
  const { getRetouchPicturesByOrderLines } = useRetouch();
  const { hasRetouchProduct } = usePriceList();
  const [retouchPictures, setRetouchPictures] = useState(null);

  useEffect(() => {
    if (!template) {
      return;
    }

    console.log("Template loaded, setting instance");

    const product = getProductByUuid(orderLine.product.uuid);

    const templateInfo = orderLine.template;

    const { year, clientCompatibilityDate } = templateInfo.data;

    const inst = createInstance(template);
    console.log("Setting resources", orderLine.template);
    const instance = {
      ...inst,
      year,
      clientCompatibilityDate,
      resources: {
        ...inst.resources,
        ...templateInfo.data.userResources,
      },
    };

    console.log("Setting instance", instance);

    dispatch({
      type: ACTIONS.SET_TEMPLATE_INSTANCE,
      templateInstance: instance,
    });

    dispatch({
      type: ACTIONS.SET_PRODUCT,
      product,
    });
  }, [orderLine, template]);

  if (!state.template) {
    return null;
  }

  const handleUpdateCart = async (resources) => {
    const templateUuid = orderLine.template.uuid;
    const updatedOrderLine = {
      ...orderLine,
      template: {
        uuid: templateUuid,
        data: {
          year: state.year,
          userResources: resources.reduce((resources, resource) => {
            resources[resource.fullId] = resource;
            return resources;
          }, {}),
        },
      },
    };
    await updateItem(updatedOrderLine);

    if (hasRetouchProduct) {
      const retouchPictures = getRetouchPicturesByOrderLines([
        updatedOrderLine,
      ]);

      if (retouchPictures.length > 0) {
        setRetouchPictures(retouchPictures);
        return;
      }
    }
    history.push("/shopping-cart/");
  };

  const handleGoBack = () => {
    history.push("/shopping-cart/");
  };

  if (retouchPictures !== null) {
    return <ProductRetouch pictures={retouchPictures} />;
  }

  return (
    <EditTemplateProduct
      mode="update"
      handleGoBack={handleGoBack}
      updateCart={handleUpdateCart}
      cartButtonLabel={t("Update cart")}
    />
  );
};
